var angular = require('angular');
angular.module('promemoria').component('auiLoader', {
  bindings: {
    active: '<',
    lock: '<'
  },
  template: require ('./loader.html'),
  controller: function ($scope, $element, $attrs) {
    this.firstLoad = true;
    this.$onChanges = function (changeObj) {
      if (!changeObj.active.previousValue && this.firstLoad) {
        this.firstLoad = false;
      }

      if (!changeObj.active.currentValue) {
        this.show = false;
        document.querySelector('body').style.overflow = 'auto';
      } else {
        this.show = true;
        if (!changeObj.lock) {
          document.querySelector('body').style.overflow = 'hidden';
        }
      }
    };
  }
  // this.$onInit = function() {
  //   // here you can do a check for your this.layout and set a value if there is none
  //   this.layout = this.layout || 'default value'; 
  // }

});



// WEBPACK FOOTER //
// ./src/js/components/loader/loader.js